import { render, staticRenderFns } from "./ChapterOverlay.vue?vue&type=template&id=450deb2e&scoped=true&"
import script from "./ChapterOverlay.vue?vue&type=script&lang=js&"
export * from "./ChapterOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ChapterOverlay.vue?vue&type=style&index=0&id=450deb2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450deb2e",
  null
  
)

export default component.exports